import Api from '../helpers/api';

// Internal administration (AD) only: reads the institution_settings catalogue
// and maintains the default_value served by /institutions/settings when an
// institution has no association of its own.
function getInstitutionSettings(cancelToken) {
  cancelToken = cancelToken === undefined ? null : cancelToken;
  return Api.get('/preset/admin/institution-settings', { cancelToken });
}

function updateDefaultValue(settingId, defaultValue) {
  return Api.put(`/preset/admin/institution-settings/${settingId}/default-value`, {
    default_value: defaultValue === null || defaultValue === undefined ? '' : defaultValue,
  });
}

// Settings of one specific institution (merged with the catalogue's
// default_value fallback), used by the "Editar instituição" screen.
function getInstitutionSettingsFor(institutionId, cancelToken) {
  cancelToken = cancelToken === undefined ? null : cancelToken;
  return Api.get(`/preset/admin/institutions/${institutionId}/settings`, { cancelToken });
}

function upsertInstitutionSettingValue(institutionId, settingId, value) {
  return Api.put(`/preset/admin/institutions/${institutionId}/settings/${settingId}`, {
    value: value === null || value === undefined ? '' : value,
  });
}

function deleteInstitutionSettingValue(institutionId, settingId) {
  return Api.delete(`/preset/admin/institutions/${institutionId}/settings/${settingId}`);
}

export const adminInstitutionSettingsService = {
  getInstitutionSettings,
  updateDefaultValue,
  getInstitutionSettingsFor,
  upsertInstitutionSettingValue,
  deleteInstitutionSettingValue,
};
